import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { resetALL } from "../../../../../../../.globals/redux/actions";
import { endpoints } from "../../../../../../../core/defaultValues";
import {
    clientMutation,
    clientQuery,
} from "../../../../../../../core/data/GraphQLApi";
import { ExceptionManager } from "../../../../../../../core/logManager";

const INIT_STATE = {
    open: false,
    loading: false,
    location: null,
    locationId: null,
    create: null,
    update: null,
    customerId: null
};

const route = "modules/workOrders/modals/createEditContact/redux/slice";

export const workOrderCreateLocation = createAsyncThunk(
    "workOrders/workOrderCreateEditLocation/createCustomerLocation",
    async (payload, { rejectWithValue }) => {

        try {
            const mutation = `
              mutation (
                    $customerId: Int!
                    $name: String!
                    $locationType: enumLocationType!
                    $address: AddressInput!
                    $latitude: Float!
                    $longitude: Float!
                    $contact: String
              ) {
                  data: createCustomerLocation (
                        customerId: $customerId
                        name: $name
                        locationType: $locationType
                        address: $address
                        latitude: $latitude
                        longitude: $longitude
                        contact: $contact
                  ) {
                    id
                  }
              }
          `;

            const response = await clientMutation(
                mutation,
                payload,
                endpoints.GRAPHQL_GENERAL_V2
            );
            return response?.data;
        } catch (exc) {
            ExceptionManager(exc, route, "createCustomerLocation");
            return rejectWithValue(exc);
        }
    }
);

export const workOrderEditLocation = createAsyncThunk(
    "workOrders/workOrderCreateEditLocation/updateCustomerLocation",
    async (payload, { rejectWithValue }) => {

        try {
            const mutation = `
              mutation (
                    $id: Int!
                    $customerId: Int
                    $name: String
                    $locationType: enumLocationType
                    $address: AddressInput
                    $latitude: Float
                    $longitude: Float
                    $contact: String
              ) {
                  data: updateCustomerLocation (
                        id: $id
                        customerId: $customerId
                        name: $name
                        locationType: $locationType
                        address: $address
                        latitude: $latitude
                        longitude: $longitude
                        contact: $contact
                  ) {
                    id
                  }
              }
          `;

            const response = await clientMutation(
                mutation,
                payload,
                endpoints.GRAPHQL_GENERAL_V2
            );
            return response?.data;
        } catch (exc) {
            ExceptionManager(exc, route, "updateCustomerLocation");
            return rejectWithValue(exc);
        }
    }
);

export const workOrderGetLocation = createAsyncThunk(
    "workOrders/workOrderCreateEditContact/getCustomerLocation",
    async (payload, { rejectWithValue }) => {

        try {
            const mutation = `
              query ($id: Int!) {
                data: getCustomerLocation(id: $id) {
                    id
                    name
                    customerId
                    locationType
                    contact
                    address
                    latitude
                    longitude
                }
            }
          `;

            const response = await clientMutation(
                mutation,
                payload,
                endpoints.GRAPHQL_GENERAL_V2
            );
            return response?.data;
        } catch (exc) {
            ExceptionManager(exc, route, "getCustomerLocation");
            return rejectWithValue(exc);
        }
    }
);

const workOrdersCreateEditLocationRedux = createSlice({
    name: "workOrders/createEditContact",
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload
                ? { ...state, ...action.payload }
                : { ...INIT_STATE };
        },
        openModalCreateEditLocation(state, action) {
            state.open = true;
            state.locationId = action?.payload?.locationId;
            state.customerId = action?.payload?.customerId;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        //workOrderCreateLocation
        builder.addCase(workOrderCreateLocation.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(workOrderCreateLocation.fulfilled, (state, action) => {
            state.loading = false;
            state.create = action.payload;
        });
        builder.addCase(workOrderCreateLocation.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        //workOrderEditLocation
        builder.addCase(workOrderEditLocation.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(workOrderEditLocation.fulfilled, (state, action) => {
            state.loading = false;
            state.update = action.payload;
        });
        builder.addCase(workOrderEditLocation.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        //workOrderGetLocation
        builder.addCase(workOrderGetLocation.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(workOrderGetLocation.fulfilled, (state, action) => {
            state.loading = false;
            state.location = action.payload;
        });
        builder.addCase(workOrderGetLocation.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = workOrdersCreateEditLocationRedux;

// Extract and export each action creator by name
export const {
    reset,
    openModalCreateEditLocation,
} = actions;

// Export the reducer, either as a default or named export
export default reducer;
